import React from 'react';
import { Section } from './Section';
import { Trophy, Layers, CheckCircle2 } from 'lucide-react';
export function ProductOverview() {
  const levels = ['Principiante', 'Intermedio', 'Avanzado', 'Adultos Mayores', 'Movilidad Funcional', 'Full Relax'];
  return <Section className="bg-brand-light relative overflow-hidden" data-id="element-283">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-brand-accent/5 blur-[120px] rounded-full pointer-events-none" data-id="element-284"></div>

      <div className="text-center mb-8 md:mb-12 relative z-10" data-id="element-285">
        <div className="inline-flex items-center justify-center bg-brand-dark px-3 py-1.5 rounded-full mb-4 border border-white/10" data-id="element-286">
          <Trophy className="w-4 h-4 text-yellow-400 mr-1.5" data-id="element-287" />
          <span className="text-xs sm:text-sm font-bold tracking-wider text-gray-200" data-id="element-288">
            SISTEMA N°1 PARA PROFES DE STRETCHING EN ARGENTINA
          </span>
        </div>

        <div className="text-brand-accent font-bold tracking-widest text-xs mb-2" data-id="element-289">
          RECURSOSFITNESS™
        </div>
        <h2 className="text-3xl md:text-5xl font-display font-black text-white mb-3" data-id="element-290">
          MEGAPACK — SISTEMA COMPLETO
        </h2>
        <p className="text-base md:text-2xl text-gray-300 max-w-3xl mx-auto font-medium" data-id="element-291">
          6 Tomos + 6 Bonos — Todos los niveles — Todo resuelto.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 items-center max-w-5xl mx-auto relative z-10" data-id="element-292">
        <div className="bg-brand-dark p-5 md:p-8 rounded-2xl border border-brand-accent/20 shadow-2xl" data-id="element-293">
          <ul className="space-y-3 md:space-y-5" data-id="element-294">
            {['+240 páginas de contenido estructurado', '60+ clases completas listas para dar', 'Stretching Base · Flexibilidad Profunda · Movilidad · Elementos · Adultos Mayores · Full Relax', 'Planificación · Variaciones · Fidelización · Comunicación', 'Funciona desde hoy mismo en tu estudio'].map((item, i) => <li key={i} className="flex items-start" data-id="element-295">
                <CheckCircle2 className="w-5 h-5 text-brand-accent mr-3 flex-shrink-0 mt-0.5" data-id="element-296" />
                <span className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-297">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        <div data-id="element-298">
          <h3 className="text-xl md:text-2xl font-display font-bold text-white mb-4 md:mb-6 flex items-center" data-id="element-299">
            <Layers className="w-5 h-5 text-brand-accent mr-2" data-id="element-300" />
            NIVELES Y ENFOQUES INCLUIDOS:
          </h3>
          <div className="flex flex-wrap gap-2" data-id="element-301">
            {levels.map((level, i) => <div key={i} className="bg-brand-dark/50 border border-white/10 px-3 py-2 rounded-lg text-gray-200 font-medium text-sm md:text-base" data-id="element-302">
                {level}
              </div>)}
          </div>
        </div>
      </div>
    </Section>;
}